import React from 'react';
import componentMap from '../../../utils/componentMap';
import ArticleFooter from './types/ArticleFooter';

const NewsletterWidget = props => {
  // Determine view
  const Component = componentMap(props, {
    articleFooter: ArticleFooter,
    default: ArticleFooter
  });

  return <Component type={Component.displayName} {...props} />;
};

NewsletterWidget.displayName = 'NewsletterWidget';

export default NewsletterWidget;
